module.exports = __webpack_public_path__ + "img/Lebanon.49991a63.gif";